import {FeatureFlagRepository} from '@domain/model/FeatureFlag/FeatureFlagRepository';
import {FeatureFlag} from '@domain/model/FeatureFlag/FeatureFlag';

export const GetFeatureFlags =
  (featureFlagRepository: FeatureFlagRepository): (() => Promise<FeatureFlag[]>) =>
  (): Promise<FeatureFlag[]> => {
    return featureFlagRepository.getFeatureFlags();
  };
